/*
 * @Author: vyron
 * @Date: 2022-07-13 16:59:41
 * @LastEditTime: 2022-07-21 18:39:49
 * @LastEditors: vyron
 * @Description: 环境变量相关(node,请求环境[dev,qa,prod])
 * @FilePath: /capability-platform/src/utils/env/index.ts
 */

export const isNodeProd = process.env.NODE_ENV === "production"

export const isAppProd = process.env.APP_ENV === "production"

export const isAppTest = process.env.APP_ENV === "test"

export const isAppDev = process.env.APP_ENV === "development"
